import * as React from 'react';
import Header from './Header';
import { Container } from 'react-bootstrap';
import "../custom.css";

export default (props: { children?: React.ReactNode }) => (
    <React.Fragment>
        <Container fluid className="mtb-sm-2">
            <Header />
            {props.children}
        </Container>
    </React.Fragment>
);
